<template>
  <div>
    <v-container>
      <h1>{{ title }}</h1>
      <!-- <quill-editor v-model="content" :options="editorOption"></quill-editor> -->
      <v-tabs>
        <v-tab class="text-none">Email Format</v-tab>
        <!-- <v-tab class="text-none">Recipient</v-tab> -->

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <format></format>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- <v-tab-item>
          <v-card flat>
            <v-card-text>
              <recipient></recipient>
            </v-card-text>
          </v-card>
        </v-tab-item> -->
      </v-tabs>
    </v-container>
  </div>
</template>
<script>
import Format from "./Format.vue";
import Recipient from "./Recipient.vue";
export default {
  metaInfo: {
    title: "Approver of OB Employee Schedule",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  data: () => ({
    title: "Approver of OB Employee Schedule",
  }),
  components: {
    Format,
    Recipient,
  },
};
</script>
